import { render, staticRenderFns } from "./BankAccountCreateEdit.vue?vue&type=template&id=4786f29f&scoped=true&"
import script from "./BankAccountCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BankAccountCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786f29f",
  null
  
)

export default component.exports